// extracted by mini-css-extract-plugin
module.exports = {"container":"AideVideo_container__3rdPh"};